import { render, staticRenderFns } from "./NavFull.vue?vue&type=template&id=52c45ffe&"
import script from "./NavFull.vue?vue&type=script&lang=js&"
export * from "./NavFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports